<template>
  <Layout :tituloPagina="`Sistema | Roles de usuarios | ${modo=='nuevo'?'Nuevo':'Edición'}`">
    <div class="row">
      <div class="col-md-7">
        <div class="card">
          <div class="card-header justify-content-between d-flex align-items-center">
            <h4 class="card-title">
              {{modo=='nuevo'?'Nuevo ': 'Edición de '}} rol de usuarios
            </h4>
            <div>
              <div class="dropdown">
                <a
                  class="dropdown-toggle"
                  href="javascript: void(0);"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <eva-icon
                    name="more-horizontal-outline"
                    data-eva-width="20"
                    data-eva-height="20"
                    :class="{
                      'fill-dark': $store.state.layout.layoutMode == 'light',
                      'fill-white': $store.state.layout.layoutMode == 'dark'
                    }"
                  ></eva-icon>
                </a>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <a
                      href="#"
                      class="dropdown-item"
                      onclick="return false"
                      @click="modo == 'nuevo' ? guardar() : actualizar()"
                      v-if="soloLectura==false"
                      v-show="
                        tienePermiso('sistema.guardarRolUsuarios', 'accion') ||
                        tienePermiso('actualizarRolUsuario', 'accion')
                      "
                    >
                      <i class="mdi mdi-content-save text-success"></i>
                      {{ modo == 'nuevo' ? 'Guardar' : 'Actualizar' }}
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item" href="#"
                      onclick="return false;" @click="cerrar()"
                    >
                      <i class="mdi mdi-close text-dark"></i>
                      Cerrar
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <label class="col-md-3">Nombre</label>
              <div class="col-md-9">
                <input
                  class="form-control"
                  placeholder="Nombre del rol de usuarios"
                  ref="nombre"
                  v-model="rol.nombre"
                  :readonly="soloLectura"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="text-right">
          <div class="btn-group">
            <button class="btn btn-secondary" @click="cerrar()">
              <i class="mdi mdi-chevron-left"></i>
              Atrás
            </button>
            <router-link :to="{ name:'bloquesFunciones', query: {id_rol: rol.id} }"
              class="btn btn-info"
              v-if="modo=='edicion'">
              <i class="bx bx-list-ol"></i>
              Permisos
            </router-link>
            <router-link :to="{ name: 'rolNotificaciones', query: {id_rol: rol.id} }"
              class="btn btn-primary" v-if="modo=='edicion'">
              <i class="bx bxs-bell-ring"></i>
              Notificaciones
            </router-link>
            <button type="submit" class="btn btn-success"
              @click="modo=='nuevo'?guardar():actualizar()"
              v-if="soloLectura==false && (tienePermiso('sistema.guardarRolUsuarios', 'accion') || tienePermiso('actualizarRolUsuario', 'accion'))"
              :disabled="bandera_spinner"
            >
              <i
                class="mdi"
                :class="!bandera_spinner ? 'mdi-content-save' : 'mdi-concourse-ci mdi-spin'"
              ></i>
              {{modo=='nuevo'?'Guardar':'Actualizar'}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <br>
  </Layout>
</template>

<script>
import RolUsuariosSrv from '@/services/RolUsuariosSrv.js'
import Layout from "@/views/layouts/main"

import { todoGetters } from "@/state/helpers"
export default {
  name: 'EdicionRolUsuario',
  components: { Layout },
  data() {
    return {
      idRol: null,
      
      modo: 'nuevo',
      soloLectura: true,
      rol: {
        id: null,
        nombre: '',
        descripcion: '',
        rutas_permiso: []
      },
      bloque: { id: null, nombre: '' },
      idBloqueRutasVisible: null,
      bandera_spinner: false
    }
  },
  computed:{
    ...todoGetters
  },
  created: function() {
    var self = this

    // Actualización del modo
    self.idRol = this.$route.params.id;
    if(self.idRol != null) {
      self.modo = 'edicion';
    }

    switch(self.modo) {
      case 'nuevo':
        self.soloLectura = false
        break;
      case 'edicion':
        self.cargarRol()
        break;
    }
  },
  methods: {
    actualizar: function() {
      var self = this

      self.bandera_spinner = true

      var rol = Object.assign({}, self.rol)

      if (rol.nombre == '') {
        iu.msg.warning('Es necesario un nombre')
        self.$refs.nombre.select()
        self.bandera_spinner = false
        return
      }

      RolUsuariosSrv.actualizar(rol).then(response => {
        iu.msg.success('Se actualizó correctamente')
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo actualizar el rol'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },

    atras: function() {
      this.$router.go(-1)
    },

    cargarRol: function() {
      var self = this
      RolUsuariosSrv.rolJSON(self.idRol).then(response => {
        self.rol = response.data
        self.soloLectura = self.rol.generico
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar el rol'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cerrar: function() {
      this.atras()
    },

    guardar: function() { 
      var self = this

      self.bandera_spinner = true

      var rol = Object.assign({}, self.rol)

      if (rol.nombre == '') {
        iu.msg.warning('Es necesario un nombre')
        self.$refs.nombre.select()
        self.bandera_spinner = false
        return
      }

      RolUsuariosSrv.guardar(rol).then(response => {
        let idRol = response.data
        self.idRol = idRol
        
        iu.msg.success('Rol guardado correctamente')
        
        setTimeout(function() {
            self.rol.id = idRol
            self.$router.replace({
              name: 'edicionRolUsuarios',
              params: { id: idRol }
            })

            self.modo = 'edicion'
          }, 1000)
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo guardar el rol'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
      })
    }
  }
}
</script>

<style scoped>

</style>